export default __webpack_public_path__ + "555fd704fc162381a28090f1d0c8695c.png";